import { AppColor, AppColorContainer } from "../AppColorContainer";

/** This is the color container light mode implementation used by getAppColorContainer interface implementation for OneNote app */
export class LightModeOneNoteAppColorContainer implements AppColorContainer {

  darkLabelColor: AppColor = { value : "#212121" };

  mediumLabelColor: AppColor = { value : "#303030" };

  lightLabelColor: AppColor = { value : "#6e6e6e" };

  timestampLabelColor: AppColor = { value: "#11100f" };

  linkColor: AppColor = { value: "#7719AA" };

  defaultBackgroundColor: AppColor = { value: "#edebe9" };

  lightBackgroundColor: AppColor = { value: "#faf9f8" };

  darkBackgroundColor: AppColor = { value: "#cccccc" };

  primaryWidgetColor: AppColor = { value: "#5B1382" };

  primaryWidgetColorOnHover: AppColor = { value: "#862EB5" };

  primaryWidgetLabelColor: AppColor = { value: "#ffffff" };

  secondaryWidgetColor: AppColor = { value: "#FFFFFF" };

  secondaryWidgetColorOnHover: AppColor = { value: "#FFFFFF" };

  secondaryWidgetLabelColor: AppColor = { value: "#323130" };

  secondaryWidgetLabelColorOnHover: AppColor = { value: "#323130" };

  secondaryWidgetBorderColor: AppColor = { value: "#BEBBB8" };

  blackColor: AppColor = { value: "#000000" };

  whiteColor: AppColor = { value: "#ffffff" };

  wordBlue: AppColor = { value: "#2e6ac5" };

  keyboardFocusColor: AppColor = { value: "#605e5c" };

  lightBlue: AppColor = { value: "#0078d4" };

  tagBlue: AppColor = { value: "#7719AA" };

  bulletGray: AppColor = { value: "#D2D0CE" };

  progressBackground: AppColor = { value: "#D5D4D2" };

  popupBackground: AppColor = { value: "#5B1382" };

  transcribeIllustrationHeadsetInnerColor: AppColor = { value: "#605D5A" };

  transcribeIllustrationHeadsetOuterColor: AppColor = { value: "#33312D" };

  transcribeIllustrationHeadsetWireColor: AppColor = { value: "#DC9FFD" };

  transcribeIllustrationCatLegsColor: AppColor = { value: "#F2D9FF" };

  transcribeIllustrationCatBodyGradientStartColor: AppColor = { value: "#D5A3F0" };

  transcribeIllustrationCatBodyGradientEndColor: AppColor = { value: "#F2D9FF" };

  transcribeIllustrationCatTailGradientStartColor: AppColor = { value: "#EBC6FF" };

  transcribeIllustrationCatTailGradientEndColor: AppColor = { value: "#F3DAFF" };

  micWidgetBorderColor: AppColor = { value: "#7719AA" };

  // TODO: change color as per one note
  charcoalColor: AppColor = { value: "#333333" };

  darkGrayColor: AppColor = {value: "#404040"};

  transcriptionIndicatorTextColor: AppColor  = {value: "#9E9E9E"};

  officeDesktopBackgroundColor: AppColor = {value: "#F0F0F0"};

  recordingIconRingsColor: AppColor = {value: "#D2BBDF"};

  listeningIconOuterColor: AppColor = {value: '#7719AA'};

  listeningIconMicColor: AppColor = {value: '#FFFFFF'};

  pauseIconOuterColor: AppColor = {value: '#FFFFFF'};

  pauseIconMicColor: AppColor = {value: '#7719AA'};

  oneDriveInfoTextColor: AppColor = {value: '#000000'};

  dropDownSelectionColor: AppColor = {value: '#0000001A'};

  dropDownHoverColor: AppColor = {value: '#F3F2F1'};

  private static instance: LightModeOneNoteAppColorContainer | null = null;

  static GetInstance() {
    if (this.instance == null) this.instance = new LightModeOneNoteAppColorContainer();

    return this.instance;
  }
}